export default function Http404Route($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.Http404', {
		url: '/404',
		controllerAs: 'vm',
		templateUrl: '/ng/hub/Error/Http404/Http404Ctrl.html?' + window.BUILD,
		resolve: {
			$title: () => 'Page Not Found',
		},
	});
}
